import { StatusCircle } from "@intrasync/react";

type Status =
  | 'new'
  | 'modeled'
  | 'drawn'
  | 'checked'
  | 'issued for construction';

interface StatusCircleProps {
  status: Status;
}

const IFCTrackerStatusCircle = ({ status }: StatusCircleProps) => {
  //   console.log('StatusCircle status', status);
  const statusColor = {
    new: 'gray',
    modeled: 'yellow',
    drawn: 'green',
    checked: 'purple',
    'issued for construction': 'blue',
  }[status];
  const size = '20px';

  return <StatusCircle color={statusColor} size={size} />;
};

export default IFCTrackerStatusCircle;
